<template>
  <ul class="dashboard--menu collapse" id="dashboardMenu">
    <li>
      <a class="dashboard--menu--item-link" href="/">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            d="M520.432,509.791a.807.807,0,0,0-.061-1.129L513.22,502.2a.87.87,0,0,0-1.162.014l-7.175,6.793a.8.8,0,0,0-.034,1.127l.179.192a.763.763,0,0,0,1.076.085l.537-.5v7.262a.8.8,0,0,0,.782.808h2.8a.794.794,0,0,0,.779-.808V512.1h3.567v5.078a.752.752,0,0,0,.731.808h2.966a.8.8,0,0,0,.78-.808v-7.159s.147.136.331.3.561.035.853-.295Z"
            transform="translate(-504.633 -501.983)"
            fill="#9f9f9f"
          ></path></svg
        >Home
      </a>
    </li>
    <li>
      <a
        class="dashboard--menu--item-link link-collapse"
        href="#menuClasses"
        data-bs-toggle="collapse"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="16"
          viewBox="0 0 14 16"
        >
          <path
            data-name="Icon awesome-book"
            d="M14,11.25V.75A.748.748,0,0,0,13.25,0H3A3,3,0,0,0,0,3V13a3,3,0,0,0,3,3H13.25a.748.748,0,0,0,.75-.75v-.5a.756.756,0,0,0-.278-.584,6.969,6.969,0,0,1,0-2.334A.745.745,0,0,0,14,11.25ZM4,4.188A.188.188,0,0,1,4.188,4h6.625A.188.188,0,0,1,11,4.188v.625A.188.188,0,0,1,10.813,5H4.188A.188.188,0,0,1,4,4.813Zm0,2A.188.188,0,0,1,4.188,6h6.625A.188.188,0,0,1,11,6.188v.625A.188.188,0,0,1,10.813,7H4.188A.188.188,0,0,1,4,6.813ZM11.919,14H3a1,1,0,0,1,0-2h8.919A11.25,11.25,0,0,0,11.919,14Z"
            fill="#9f9f9f"
          ></path></svg
        >Classes
      </a>
      <ul
        class="dashboard--menu--sub-menu collapse show"
        id="menuClasses"
        v-if="$store.getters.StateUser.user.user_type == 'student'"
      >
        <li>
          <router-link to="/BookedClasses" class="dashboard--menu--item-sublink"
            >Booked</router-link
          >
        </li>
      </ul>
      <ul
        class="dashboard--menu--sub-menu collapse"
        id="menuClasses"
        v-if="$store.getters.StateUser.user.user_type == 'tutor'"
      >
        <li>
          <a class="dashboard--menu--item-sublink" href="#">New Reserved</a>
        </li>
        <li>
          <router-link
            to="/CurrentClasses"
            class="dashboard--menu--item-sublink"
            >Current</router-link
          >
        </li>
        <li><a class="dashboard--menu--item-sublink" href="#">Archived</a></li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted(){

  },
};
</script>
<style>
  .dashboard--menu--item-link {
    color: #9f9f9f !important;
  }
</style>
